import { render } from "./Spacer.vue?vue&type=template&id=747f3ab7"
import script from "./Spacer.vue?vue&type=script&lang=js"
export * from "./Spacer.vue?vue&type=script&lang=js"
script.render = render

export default script